import React, { RefObject, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { RelativePathString, useFocusEffect, useRouter, useScrollToTop } from 'expo-router';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppUtilities from "@/utilities/AppUtilities";
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setLoggedIn } from '@/state/user';
import { Gender } from '@/types/user_info';
import { CommunityMembership } from "@/types/community_membership";
import JoinAndPay from '@/components/JoinAndPay';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
});

export default function Pay() {
  const scrollRef = useRef<ScrollView>(null);
  
  useFocusEffect(
    useCallback(() => {
      scrollRef.current?.scrollTo({ y: 0, animated: true });
    }, [scrollRef])
  );

  return (
    <BasicScrollView center={true} ref={scrollRef as RefObject<ScrollView>}>
      <Meta title={"Payment"} />
      <JoinAndPay />
      <Footer />
    </BasicScrollView>
  );
}
